/**
 * ImageCropper Styled Components - Created by Jesus Apodaca on 08/08/19.
 */
import styled from 'styled-components'
import { BLACK } from '../../theme/colors'

const checkerboardBackground = `
  repeating-conic-gradient(
    #ccc 0% 25%,
    #fff 0% 50%
  )
  0 0 / 16px 16px
`
export const Text = styled.div`
  position: absolute;
  bottom: 10px;
  left: 42%;
  text-align: center;
  display: inline-flex;
  height: 22px;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.40);
  backdrop-filter: blur(2px);
  color: #FFF;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
`

export const RadioContainer = styled.div`
  .ant-radio-group {
    width: 100%;
    text-align: center;
  }
  .ant-radio-button-wrapper {
    background: #fafafa !important;
    border-color: #e8e8e8 !important;
  }
  .ant-radio-button-wrapper-checked {
    background: #C91731 !important;
    border-color: #C91731 !important;
  }
`

export const SaveButton = styled.div`
  width: 64px;
  background: #302628;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 48px;
  font-size: 14px;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.2s;
  &#skipBtn {
    margin-right: 18px;
    color: #302628;
    background-color: #fff;
    border: 1px solid #302628;
  }
  &:hover {
    color: ${BLACK};
    background: white;
  }
`

export const CropperContainer = styled.div<{secondary?: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 10px;
  background: ${checkerboardBackground};

  .ReactCrop {
    max-width: 100%;
  }

  .ReactCrop__child-wrapper {
    background: ${checkerboardBackground};
  }
`

export const Loader = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  background: #ffffffb0;
`

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: stretch;
`

export const CanvasContainer = styled.div`
  flex: 1;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  background: ${checkerboardBackground};
`

export const ControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 35%;
  align-items: center;
  color: #000;
  padding: 44px 24px 24px;
  background: #FFF;
  h4 {
    width: 100%;
    color: #302628;
    font-size: 20px;
    font-weight: 500;
  }
`

export const BackgroundRemovalContainer = styled.div`
  margin-top: 26px;
  background-color: #F7F7F7;
  padding: 16px;
  border-radius: 8px;
`

export const CroppingFormatContainer = styled.div`
  width: 100%;
  margin-top: 26px;
  background-color: #F7F7F7;
  padding: 16px;
  border-radius: 8px;
`

export const Subtitle = styled.div`
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  color: #625F5F;
  text-transform: uppercase;
`

export const ActionIcon = styled.div`
  margin-right: 12px;
  width: 16.22px;
  height: 16.22px;
  border: 1px solid #D7D1D2;
  border-radius: 3px;
  &.none {
    border: none;
  }
  &.circle {
    border-radius: 50%;
  }
  &.horizontal {
    height: 11.22px;
  }
  &.freeform {
    border: 1px dashed #9c9c9c;
    width: 12px;
  }
`
export const Action = styled.div`
  &.none {
    display: none;
  }
  display: flex;
  align-items: center;
  align-self: stretch;
  height: 32px;
  border: 1px solid #D7D1D2;
  border-radius: 4px;
  background: #FFF;
  color: #625F5F;
  margin-bottom: 8px;
  cursor: pointer;
  padding: 7px 97px 7px 10px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.3px;
  &.active {
    color: #302628;
    background: #E8E5E5;
    border: 1px solid #302628;
  }
  &[data-disabled="true"] {
    cursor: not-allowed;
    opacity: 0.6;
    pointer-events: none;
  }
  &#skip {
    width: 164px;
    height: 44px;
    padding: 12px 24px;
    justify-content: center;
    border-radius: 24px;
    border: 1px solid #131112;
    background: #FFF;
    margin-bottom: 0px;
    margin-right: 20px;
    color: #302628;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: capitalize;
  }
  &#saveChanges {
    width: 164px;
    height: 44px;
    padding: 12px 24px;
    justify-content: center;
    border-radius: 24px;
    border-color: 1px solid #131112;
    background: #302628;
    margin-bottom: 0px;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: capitalize;
  }
  &#removeBackground {
    justify-content: center;
    height: 40px;
    padding: 12px 24px;
    color: #302628;
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
    letter-spacing: 0.5px;
    border-radius: 6px;
    background: #FFFFFF;
    border: 1px solid #302628;
    &[data-background-removed="true"] {
      background: #D7D1D2;
      color: #8F8889;
    }
    .ant-spin {
      line-height: 0;
    }
  }
  &#undoRemoval {
    justify-content: center;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    color: #302628;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-decoration-line: underline;
    & svg {
      margin-right: 8px;
    }
  }
  &#clearCrop,
  &#applyCrop {
    flex: 1;
    justify-content: center;
    height: 40px;
    margin-bottom: 0;
    padding: 12px 24px;
    color: #302628;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: capitalize;
  }
  &#clearCrop {
    color: #302628;
    background: unset;
    border: unset;
    text-decoration: underline;
  }
  &#applyCrop {
    color: #302628;
    background: #FFF;
    border: 1px solid #302628;
  }
  &#undoCrop {
    justify-content: center;
    color: #302628;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-decoration-line: underline;
    & svg {
      margin-right: 8px;
    }
  }
`

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #D9D9D9;
  border-radius: 0 0 16px 16px;
  #footNote {
    color: #302628;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
  &[data-store='true'] {
    padding: var(--spacing-16) var(--spacing-32);
    background: var(--neutral-white);
    #footNote {
      text-align: left;
      max-width: 278px;
    }
    #saveChanges {
      width: 200px;
    }
    @media (max-width: 767px) {
      padding: var(--spacing-16);
      flex-flow: column;
      gap: 12px;
      align-items: start;
      & > div {
        width: 100%;
      }
      #saveChanges {
        width: 100%;
        height: 48px;
      }
    }
  }
  
`

export const ActionApplied = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2196F3;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  & svg {
    margin-right: 8px;
  }
`

export const CropAction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  margin-top: 12px;
  .crop-action-buttons {
    display: flex;
    flex-direction: row;
    gap: 12px;
    width: 100%;
    > #clearCrop,
    > #undoCrop,
    > #applyCrop {
      flex: 0 0 calc((100% - 12px) / 2);
      max-width: calc((100% - 12px) / 2);
      min-width: 0;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ImageCropper/styledComponents.tsx